const typesRoles = {
  1: "ADMIN",
  2: "COORDINATOR",
  3: "TEACHER",
  4: "STUDENT",
};

export default typesRoles;
